/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientFeatureSwitchViewModel } from '../../models/client-feature-switch-view-model';

export interface GetClientFeatures$Params {
      body?: {
'clientID'?: number;
}
}

export function GetClientFeatures(http: HttpClient, rootUrl: string, params?: GetClientFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientFeatures.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>;
    })
  );
}

GetClientFeatures.PATH = '/api/Clients/GetClientFeatures';
